<template>
  <button
    :disabled="disable || loading"
    :name="name"
    :class="
      outline
        ? 'soha-btn-outline soha-btn-outline-' + variant
        : 'soha-btn soha-btn-' + variant
    "
    :style="
      'height:' + convertHeight + 'rem;' + 'width:' + convertWidth + 'rem;'
    "
    @click="$emit('btn-click', $event)"
  >
    <span
      v-if="!leftIcon && icon && !loading"
      class="svg-icon svg-icon-md"
      :class="[
        outline ? 'svg-icon-' + variant : 'svg-icon-white',
        text && 'mr-4',
      ]"
    >
      <inline-svg :src="`/media/svg/soha/icons/${icon}.svg`" />
    </span>

    <span v-if="!loading">{{ text }}</span>

    <span
      v-if="leftIcon && icon && !loading"
      class="svg-icon svg-icon-md ml-4"
      :class="[outline ? 'svg-icon-' + variant : 'svg-icon-white']"
    >
      <inline-svg :src="`/media/svg/soha/icons/${icon}.svg`" />
    </span>

    <soha-circular-loading
      v-if="loading"
      :variant="outline ? variant : 'white'"
      :size="loadingSize"
      style="margin-top: 0.615rem"
    />
  </button>
</template>

<script>
import "@/assets/css/components/base/button.scss";
import "@/assets/css/components/base/circular-loading.css";

export default {
  name: "SButton",
  
  props: {
    width: {
      default: "185",
      type: [String, Number],
    },
    height: {
      default: "40",
      type: String,
    },
    text: {
      default: null,
      type: String,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    outline: Boolean,
    leftIcon: {
      default: false,
      type: Boolean,
    },
    icon: {
      default: null,
      type: String,
    },
    variant: {
      default: "primary",
      type: String,
    },
    name: {
      type: String,
      require: true,
      default: null,
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['btn-click'],

  computed: {
    loadingSize() {
      return this.height - 20;
    },

    convertHeight() {
      return this.height / 13;
    },

    convertWidth() {
      return this.width / 13;
    },
  },
};
</script>

<style scoped></style>
